export default {
  'meta': {
    'langName': 'GERMAN',
    'lang': 'Deutsch'
  },
  'title': 'PRODUKTRÜCKRUF E-SCOOTER SD500E ODER MD500E DER MARKE B\'TWIN',
  'description': 'Hallo,\n\ndu hast einen E-Scooter SD500E oder MD500E der Marke B\'TWIN erworben, wofür wir uns herzlich bedanken.  \n\nDa deine Sicherheit für uns oberste Priorität hat, bitten wir dich, die folgenden Informationen zur Kenntnis zu nehmen. \n\nIm Rahmen unserer kontinuierlichen Qualitätskontrollen haben die Expert:innen unserer Marke B\'TWIN festgestellt, dass einige der E-Scooter SD500E und MD500E einen sicherheitsrelevanten Mangel aufweisen können. Bei intensiver Nutzung kann es zu einem Riss an der Verbindungsstelle zwischen Rahmen und Vorbau kommen. Dieser Mangel kann zum Bruch dieser Verbindungsstelle führen, was für den Fahrer eine Sturzgefahr zur Folge haben könnte. \n\nWir bitten dich, die folgenden Fragen zu beantworten, damit wir dir eine Lösung zur sicheren Nutzung deines Produkts anbieten können.\n\nWir entschuldigen uns für die Unannehmlichkeiten und bedanken uns für dein Vertrauen.\n\nDein Decathlon Team\n\n',
  'emailConfirmation': {
    'title': 'Bitte bestätige uns als Erstes deine E-Mail-Adresse und das Land deines Wohnsitzes: '
  },
  'fields': {
    'country': 'Land',
    'address': 'Mailadresse',
    'email': 'Mailadresse',
    'phonePrefix': 'Ländervorwahl',
    'phone': 'Telefonnummer',
    'validations': {
      'phoneOrEmail': 'Bitte gib mindestens eine E-Mail-Adresse ODER eine Telefonnummer an.',
      'email': 'Bitte gib eine gültige E-Mail-Adresse ein',
      'phone': 'Bitte gib eine gültige Telefonnummer ein',
      'selectAddress': 'Bitte wähle eine vollständige Adresse aus der Liste aus (Hausnummer, Straße und Ort).',
      'incompleteAddress': 'Die Adresse muss eine Hausnummer, eine Straße und einen Ort enthalten. Gib mindestens die Hausnummer und den Straßennamen ein und wähle dann einen Vorschlag aus.'
    },
    'firstName': 'Nachname',
    'lastName': 'Vorname',
    'deliveryAddress': 'Anschrift',
    'additionalAddress': 'Adresszusatz',
    'city': 'Stadt',
    'zip': 'Postleitzahl',
    'readConfirmation': 'Ich habe meine Angaben überprüft, die Informationen zur Kenntnis genommen und verpflichte mich, diese einzuhalten.',
    'choose': 'Auswählen',
    'required': 'Dieses Feld ist erforderlich',
    'deliveryAddressHelp': 'Gib die Hausnummer und den Straßennamen ein und wähle anschließend eine vollständige Adresse aus der Liste aus.',
    'streetOnlyHint': 'Füge eine Hausnummer hinzu'
  },
  'ownerCheck': {
    'title': 'Bist du noch im Besitz eines oder mehrerer E-Scooter der Modelle SD500E und MD500E der Marke B\'TWIN?'
  },
  'yes': 'JA',
  'no': 'NEIN',
  'ownerChanged': {
    'title': 'Hast du die Kontaktdaten des/der aktuellen Eigentümer(s)?',
    'confirmation': 'Liebe Kundin, lieber Kunde,\n\nvielen Dank, dass du bei unserer Qualitätsmaßnahme mitmachst.\n\nWir entschuldigen uns für die Unannehmlichkeiten und danken dir für dein Vertrauen.\n\nDein Decathlon Team'
  },
  'recall': {
    'title': 'Gib uns bitte die Anzahl der E-Scooter der Modelle SD500E und MD500E der Marke B\'TWIN an',
    'descriptionSd500': 'E-Scooter  SD500E',
    'descriptionEmd500e': 'E-Scooter  MD500E',
    'modelNumberHelp': 'Die Modellbezeichnung (SD500E oder MD500E) findest du an der Unterseite deines E-Scooters, wie hier abgebildet',
    'quantity': 'Menge',
    'confirmation': 'Vielen Dank für das Ausfüllen dieses Formulars. Deine Anfrage wurde erfolgreich registriert. \n\nWir werden dir innerhalb von maximal 20 Tagen den Termin mitteilen, ab dem du die Reparatur durchführen kannst.\n\nWir wünschen dir einen schönen Tag,\n\nDein Decathlon Team'
  },
  'repair': {
    'title': 'Reparatur mit deiner Mithilfe',
    'description': 'Wir bitten dich, ihn nicht mehr zu benutzen.\n\nEin Reparaturset und eine Anleitung werden dir nach Hause geschickt, damit du deinen E-Scooter sicher weiternutzen kannst. Dieses Set wird dir kostenlos zugeschickt, die Montage ist einfach und schnell.\n\nNachdem wir deine Daten erfasst haben, werden wir uns innerhalb von maximal 20 Tagen mit dir in Verbindung setzen, um dir mitzuteilen, ab wann das Set verfügbar sein wird. Wir werden alles tun, um diese Fristen zu verkürzen und dich zufrieden zu stellen.',
    'videoLink': 'Link zum Video',
    'store': 'Link zur Anleitung',
    'kitLabel': 'Komplettes Reparaturset',
    'docLabel': 'Reparaturanleitung',
    'callToAction': 'Hier klicken, um das Reparaturset kostenlos zu erhalten',
    'infoConfirmation': 'Bitte überprüfe deine Angaben',
    'validateConfirmation': 'Bestätigen',
    'backConfirmation': 'Zurück'
  },
  'repairRequest': {
    'title': 'Bitte gib die folgenden Informationen ein, um dein Reparaturset zu erhalten:'
  },
  'form': {
    'submit': 'Weiter'
  },
  'status': 'Translation validated by COUNTRY'
} as const
